import { noOp } from '../../../shared/helpers'

export class CaptionsManager {
  constructor(videoElement) {
    this.videoElement = videoElement
    this.handlers = { onEnter: noOp, onExit: noOp, onCaptionsAvailable: noOp }
  }

  init() {
    this.videoElement.addEventListener('loadeddata', this._onLoadedData)
    return this
  }

  onEnter(cb) {
    this.handlers.onEnter = cb
    return this
  }

  onExit(cb) {
    this.handlers.onExit = cb
    return this
  }

  onCaptionsAvailable(cb) {
    this.handlers.onCaptionsAvailable = cb
    return this
  }

  destroy() {
    this.videoElement.removeEventListener('loadeddata', this._onLoadedData)
  }

  _onLoadedData = () => {
    const textTrack = this._findTextTrackBy(['captions', 'subtitles'])
    if (textTrack) {
      if (textTrack.cues?.length > 0) {
        this.handlers.onCaptionsAvailable(true)
        this._onTextTrack(textTrack)
      } else {
        textTrack.mode = 'hidden' // Ensure the text track is active
        textTrack.addEventListener('cuechange', this._onCueChange)
      }
    }
  }

  _findTextTrackBy = (kinds = []) => {
    kinds = typeof kinds === 'string' ? [kinds] : kinds
    const textTracks = this.videoElement?.textTracks
    if (textTracks && textTracks.length > 0) {
      for (let i = 0; i < textTracks.length; i++) {
        const textTrack = textTracks[i]
        if (textTrack instanceof TextTrack && kinds.includes(textTrack.kind)) {
          return textTrack
        }
      }
    }
  }

  _onCueChange = (ev) => {
    const textTrack = ev.target
    if (textTrack.mode === 'showing') {
      this.trackReady = true
      this.handlers.onCaptionsAvailable(textTrack.cues?.length > 0)
      this._onTextTrack(textTrack)
    }
  }

  _onTextTrack = (textTrack) => {
    if (textTrack) {
      this._subscribeCueEvents(textTrack)
      textTrack.removeEventListener('cuechange', this._onCueChange)
    }
  }

  _subscribeCueEvents = (textTrack) => {
    if (textTrack) {
      textTrack.oncuechange = () => {
        const cues = textTrack.activeCues
        if (cues?.length > 0) {
          const newCaptions = []
          for (let i = 0; i < cues.length; i++) {
            const cue = cues[i]
            newCaptions.push({
              id: cue.id,
              text: cue.text,
            })
            cue.onexit = (ev) => {
              const cue = ev.target
              this.handlers.onExit(cue.id)
            }
          }
          this.handlers.onEnter(newCaptions)
        } else {
          this.handlers.onEnter([])
        }
      }
    }
  }
}
